import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="components--segmented-toggle"
export default class extends Controller {
  static get targets() {
    return ['input', 'error'];
  }

  connect() {
    this.form?.addEventListener('submit', this.validate.bind(this));

    if (this.activeButton) {
      this.errorTarget.classList.add('d-none');
      this.dispatchChange(this.activeButton);
    }
  }

  get activeButton() {
    return this.element.querySelector('.segmented-toggle__option.is-active');
  }

  get form() {
    return this.element.closest('form');
  }

  validate(event) {
    const required = this.element.dataset.required === 'true';
    if (!required) return;

    if (!this.inputTarget.value) {
      this.errorTarget.classList.remove('d-none');
      event.preventDefault();
    }
  }

  select(event) {
    const button = event.currentTarget;

    this.element
      .querySelectorAll('.segmented-toggle__option')
      .forEach((option) => option.classList.remove('is-active'));

    button.classList.add('is-active');
    this.errorTarget.classList.add('d-none');

    if (this.hasInputTarget) {
      this.inputTarget.value = button.dataset.value;
      this.inputTarget.dataset.label = button.dataset.label;
    }

    this.dispatchChange(button);
  }

  dispatchChange(button) {
    const customEvent = new CustomEvent('segmented-toggle:change', {
      bubbles: true,
      detail: { button },
    });

    document.dispatchEvent(customEvent);
  }
}
